const pageIndex = {
  '/': 'Continue on article 1'
}
const splashes = [
  'Continued on page ',
  'Read more on page ',
  'Full report on page '
]
let index = 1

export default function articleNumber (Site, $) {
  Site.widget('article-number', {
    _create () {
      let key = this.options.name
      this.getSplash = randFromArr(splashes)

      // Make the index the href if this.element is a link
      if (this.element.is('a')) {
        const href = this.element.attr('href')
        if (isLocal(href)) {
          key = href
        }
      }

      this.number = this.element.find('.article-number')

      if (!pageIndex[key]) {
        index += toDP(random(1, 4), 0)
        pageIndex[key] = `${this.getSplash()} ${index}`
      }

      this.render(pageIndex[key])
    },
    render (str) {
      if (!this.number) return
      this.number.text(str)
    }
  })
}

function random (min, max) {
  return (Math.random() * (max - min)) + min
}

function randFromArr (arr) {
  const original = arr
  let current = original.slice()

  return function () {
    if (!current.length) {
      current = original.slice()
    }
    const index = toDP(random(0, current.length - 1))
    return current.splice(index, 1)
  }
}

function toDP (num, dp = 0) {
  return Math.round(num * 10 ** dp) / 10 ** dp
}

const host = new RegExp(window.location.host)

function isLocal (href) {
  return !href.includes('http') || host.test(href)
}
